module.exports = __webpack_public_path__ + "static/img/li_top3_top.0b96cc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/li_top3_top.png
// module id = 09Te
// module chunks = 1